import { render } from "./ConditionalsIfForm.vue?vue&type=template&id=2647a702"
import script from "./ConditionalsIfForm.vue?vue&type=script&lang=js"
export * from "./ConditionalsIfForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__